var React = require('react');

function SubmitArrowMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.9706 1.02944C18.9706 0.477153 18.5228 0.0294373 17.9706 0.029437L8.97056 0.0294378C8.41828 0.0294375 7.97056 0.477153 7.97056 1.02944C7.97056 1.58172 8.41828 2.02944 8.97056 2.02944L16.9706 2.02944L16.9706 10.0294C16.9706 10.5817 17.4183 11.0294 17.9706 11.0294C18.5228 11.0294 18.9706 10.5817 18.9706 10.0294L18.9706 1.02944ZM1.70711 18.7071L18.6777 1.73654L17.2635 0.322331L0.292893 17.2929L1.70711 18.7071Z","fill":"#E3232A"}));
}

SubmitArrowMobile.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = SubmitArrowMobile;

SubmitArrowMobile.default = SubmitArrowMobile;
